import { KoobSelectLanguageField } from '@koob/ui';
import { getLanguages } from 'api/languages';

const SelectLanguageField = props => (
  <KoobSelectLanguageField {...props} getLanguages={getLanguages} />
);

export default SelectLanguageField;
